module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/1-38a7df7d977b12ecbbf6def75d9d422d.svg";